import { PartnerModel } from '../../user/modal/partner-model';

export class LocationMasterModel {
  id: number;
  name: string;
  description: string;
  address: string;
  isDeleted = false;
  lat: number;
  lon: number;
  partner: PartnerModel;
  party: number;

  //Angular use
  location: string;
}
